<div id="periodiekeUitkeringenSectie">

    <form [formGroup]="periodiekeUitkeringen">
        <div formArrayName="ontvangenPU">
            <div *ngFor="let ontvangsten of ontvangenPU.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <div class="col-auto row">
                    <snelstart-ui-text-form-control (change)=(saveForm())
                                                    [label]="i === 0 ? 'Omschrijving uitkering' : ''"
                                                    class="custom-input-250"
                                                    formControlName="omschrijving"
                                                    id="description"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Bedrag' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="bedrag"
                                                      id="bedragPOU"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button
                            (change)=(saveForm())
                            (click)="verwijderRijOntvangenPU(i)"
                            [class]="i === 0 ? 'firstrowbutton' : ''"
                            class="col-auto"
                            icon="trash"
                            id="buttonDelete"
                            size="medium"
                            type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>

        <div *ngIf="ontvangenPU.length === 0">
            <snelstart-ui-button (click)="addRijOntvangenPU()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Periodieke uitkering invullen
            </snelstart-ui-button>
        </div>
        <div *ngIf="ontvangenPU.length > 0">
            <snelstart-ui-button (click)="addRijOntvangenPU()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Uitkering toevoegen
            </snelstart-ui-button>
        </div>


        <div formArrayName="kostenPU">
            <div *ngFor="let kosten of kostenPU.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <div class="col-auto row">
                    <snelstart-ui-text-form-control (change)=(saveForm())
                                                    [label]="i === 0 ? 'Omschrijving kosten' : ''"
                                                    class="custom-input-250"
                                                    formControlName="omschrijving"
                                                    id="omschrijvingKosten"

                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Bedrag' : ''"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="bedrag"
                                                      id="bedragKosten"
                                                      prefix="€"

                    >
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-button (change)=(saveForm())
                                         (click)="verwijderRijKostenPU(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         class="col-auto"
                                         icon="trash"
                                         id="buttonDelete"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>

        <div *ngIf="kostenPU.length === 0">
            <snelstart-ui-button (click)="addRijKostenPU()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Kosten periodieke uitkering invullen
            </snelstart-ui-button>
        </div>
        <div *ngIf="kostenPU.length > 0">
            <snelstart-ui-button (click)="addRijKostenPU()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Kosten toevoegen
            </snelstart-ui-button>
        </div>

        @if (!toonRevisierente && (periodiekeUitkeringen.get('revisierente')?.value === null || periodiekeUitkeringen.get('revisierente')?.value === undefined)) {
            <snelstart-ui-button (click)="addRevisierente()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Revisierente invullen
            </snelstart-ui-button>
        }

        @if (toonRevisierente || (periodiekeUitkeringen.get('revisierente')?.value !== null && periodiekeUitkeringen.get('revisierente')?.value !== undefined)) {
            <div class="col-auto row">
                <snelstart-ui-text-form-control [disabledControl]=true
                                                class="custom-input-250"
                                                formControlName="omschrijving"
                                                id="description"
                                                label="Omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="revisierente"
                                                  id="revisierentePU"
                                                  label="Bedrag"
                                                  prefix="€">
                </snelstart-ui-number-form-control>

                <snelstart-ui-button (click)="verwijderRevisierente()"
                                     class="col-auto pt-3"
                                     icon="trash"
                                     size="medium"
                                     type="secondary">
                </snelstart-ui-button>
            </div>
        }
    </form>

</div>
